export default "void main()\t{\n\tgl_Position = vec4( position, 1.0 );\n}"